module.exports = __webpack_public_path__ + "static/media/full-screen-selected-icon.c8d36075.svg";